module.exports = __webpack_public_path__ + "static/img/lun_9.47a6c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_9.jpg
// module id = p6B0
// module chunks = 1